import { Avatar, DocumentsZhk16, UIHeading1, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import { THomeownerProof } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import * as style from './style.css';
import { HOMEOWNER_PROOF_TEXTS } from '../../../../constants/homeownerProofTexts';

export interface IHomeownerLayoutProps {
  userName: string;
  avatar: string | null;
  homeownerProofs: THomeownerProof[] | null;
  contactButton: React.ReactElement | null;
  chatButton: React.ReactElement | null;
}

export const HomeownerInfo: React.FC<IHomeownerLayoutProps> = ({
  avatar,
  userName,
  homeownerProofs,
  contactButton,
  chatButton,
}) => {
  return (
    <div className={style['container']}>
      <div className={style['left']}>
        <div className={style['title']}>
          <UIText2 color="black_100">Собственник</UIText2>
          <UIHeading1 color="black_100">{userName}</UIHeading1>
        </div>

        <ul className={style['proofs']}>
          {homeownerProofs?.map((proof, index) => (
            <li key={proof + index}>
              <DocumentsZhk16 color="primary_100" />
              <UIText1 color="black_100">{HOMEOWNER_PROOF_TEXTS[proof]}</UIText1>
            </li>
          ))}
        </ul>

        <div className={style['buttons']}>
          {contactButton && <div className={style['button']}>{contactButton}</div>}

          {chatButton && <div className={style['button']}>{chatButton}</div>}
        </div>
      </div>

      <div className={style['avatar']}>
        <Avatar size={80} src={avatar} />
      </div>
    </div>
  );
};
